<template>
  <div
    :style="
      index % 2 == 1
        ? 'background: #dedede; padding:5px;float:left;width: 100%;'
        : ' padding:5px;float:left;width: 100%;'
    "
  >
    <b>{{ index }}、{{ item.questionName }}</b>

    <!-- 新加的记录 -->
    <div
      v-for="(answerItem, index) in addAnswer"
      :key="index"
      style="width: 100%; height: 40px; line-height: 40px; float: left"
    >
      <div
        style="
          width: 450px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          float: left;
        "
        :title="answerItem.optionalName"
      >
        {{ answerItem.optionalName }}
      </div>

      <div style="float: left; width: 260px">
        发生时间：
        <el-date-picker
          v-model="answerItem.happenTime"
          type="date"
          style="width: 150px"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @change="selectChanged"
        />
      </div>
      <div style="float: left; width: 380px">
        备注：
        <el-input
          v-model="answerItem.remark"
          style="width: 300px"
          @change="selectChanged"
        />
      </div>
      <div
        v-if="item.multipleChoiceFlag && checkPermission('资料确认信息:可删', permList)"
        style="
          float: left;
          width: 20px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #99a9bf;
          cursor: pointer;
        "
        @click="reduce(answerItem)"
      >
        -
      </div>
    </div>
    <!-- 已经添加的记录 -->
    <template v-if="item.multipleChoiceFlag">
      <div
        v-for="(answerItem, index) in item.answers"
        :key="index"
        style="width: 100%; height: 40px; line-height: 40px; float: left"
      >
        <div
          style="
            float: left;
            width: 450px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
          :title="answerItem.optionalName"
        >
          {{ answerItem.optionalName }}
        </div>

        <div style="float: left; width: 260px">
          发生时间：
          <el-date-picker
            v-model="answerItem.happenTime"
            type="date"
            style="width: 150px"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="selectChanged"
          />
        </div>
        <div style="float: left; width: 380px">
          备注：
          <el-input
            v-model="answerItem.remark"
            style="width: 300px"
            @change="selectChanged"
          />
        </div>
        <div
          v-if="checkPermission('资料确认信息:可删', permList)"
          style="
            float: left;
            width: 20px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            border: 1px solid #99a9bf;
            cursor: pointer;
          "
          @click="reduceChoiceFlag(answerItem)"
        >
          -
        </div>
      </div>
    </template>
    <!-- 要操作的 -->
    <div
      v-if="showOptions.length > 0"
      style="width: 100%; height: 40px; line-height: 40px; float: left"
    >
      <div style="float: left; width: 250px">
        <el-select v-model="select" placeholder="请选择" @change="selectChanged">
          <el-option
            v-if="
              item.multipleChoiceFlag ||
                (!item.multipleChoiceFlag && (item.answers == [] || item.answers == null))
            "
            label="==请选择=="
            value="-1"
          />
          <el-option
            v-for="(ruleItem, index) in showOptions"
            :key="index"
            :label="
              ruleItem.optionalName.length > 60
                ? ruleItem.optionalName.substring(0, 60) + '...'
                : ruleItem.optionalName
            "
            :value="ruleItem.optionalCode"
          />
        </el-select>
      </div>

      <div style="float: left; width: 260px">
        发生时间：
        <el-date-picker
          v-model="currentItem.happenTime"
          type="date"
          style="width: 150px"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @change="selectChanged"
        />
      </div>
      <div style="float: left; width: 380px">
        备注：
        <el-input
          v-model="currentItem.remark"
          style="width: 300px"
          @change="selectChanged"
        />
      </div>
      <div
        v-if="item.multipleChoiceFlag && checkPermission('资料确认信息:可加', permList)"
        style="
          float: left;
          width: 20px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          border: 1px solid #99a9bf;
          cursor: pointer;
        "
        @click="add"
      >
        +
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    item: {
      value: Array,
      default: []
    },
    index: {
      value: String,
      default: ''
    }
  },

  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
      currentItem: {
        optionalCode: 0,
        optionalName: '',
        happenTime: '',
        remark: ''
      },
      showOptions: [],
      select: '==请选择==',
      addAnswer: []
      //   activeAddAnswer: [], // 记录被选中的选项
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    })
  },

  watch: {
    item(newValue, oldValue) {
      this.init()
    }
  },

  created() {
    this.init()
  },
  methods: {
    init() {
      var that = this.item
      // 如果不是多选
      if (!that.multipleChoiceFlag && that.answers != null) {
        this.select = that.answers[0].optionalName
        this.currentItem = that.answers[0]
      } else {
        this.select = '==请选择=='
        this.currentItem = {
          optionalCode: '',
          optionalName: '',
          happenTime: '',
          remark: ''
        }
      }
      this.addAnswer = []
      this.showOptions = that.options
      this.checkItemIsAdded()
    },

    add() {
      if (this.select == '==请选择==') {
        this.$alert('请先选择再点击添加记录！')
        return
      }

      var newItem = {
        optionalCode: this.currentItem.optionalCode,
        optionalName: this.currentItem.optionalName,
        happenTime: this.currentItem.happenTime,
        remark: this.currentItem.remark
      }
      this.addAnswer.push(newItem)
      this.select = '==请选择=='
      this.currentItem.happenTime = ''
      this.currentItem.remark = ''

      var updateArray = []
      this.addAnswer.forEach((i) => {
        updateArray.push(i)
      })
      if (this.item.answers != null) {
        this.item.answers.forEach((i) => {
          updateArray.push(i)
        })
      }
      this.checkItemIsAdded()
    },

    reduce(currentItem) {
      var currentSelect = []
      this.addAnswer.forEach((item) => {
        if (currentItem.optionalCode != item.optionalCode) {
          currentSelect.push(item)
        }
      })
      this.addAnswer = currentSelect

      var updateArray = []
      if (this.select != '==请选择==') {
        updateArray.push(this.item.answers)
      }
      this.addAnswer.forEach((i) => {
        updateArray.push(i)
      })

      if (this.item.answers != null) {
        this.item.answers.forEach((i) => {
          updateArray.push(i)
        })
      }
      this.checkItemIsAdded()
      this.$emit('updateRuleResult', this.item.questionCode, updateArray)
    },

    reduceChoiceFlag(currentItem) {
      var currentSelect = []
      const _currentItem = this.currentItem
      this.item.answers.forEach((item) => {
        if (currentItem.optionalCode != item.optionalCode) {
          currentSelect.push(item)
        }
      })
      this.item.answers = currentSelect

      var updateArray = []
      if (_currentItem.optionalCode) {
        updateArray = [...updateArray, _currentItem]
      }
      //   if (this.select != "==请选择==") {
      //     if (this.item.answers.length) {
      //       updateArray.push(this.item.answers);
      //     }
      //   }
      this.addAnswer.forEach((i) => {
        updateArray.push(i)
      })

      if (this.item.answers != null) {
        this.item.answers.forEach((i) => {
          updateArray.push(i)
        })
      }

      // 去重
      const obj = {}
      updateArray = updateArray.reduce((item, next) => {
        obj[next.key] ? '' : (obj[next.key] = true && item.push(next))
        return item
      }, [])

      this.checkItemIsAdded()
      this.$emit('updateRuleResult', this.item.questionCode, updateArray)
    },

    selectChanged(value) {
      var vm = this
      // 循环给当前选择的规则赋值
      for (var i = 0; i < vm.item.options.length; i++) {
        if (vm.item.options[i].optionalCode == value) {
          var currentSelect = vm.item.options[i]
          vm.currentItem.optionalCode = currentSelect.optionalCode
          vm.currentItem.optionalName = currentSelect.optionalName
          vm.select = currentSelect.optionalName

          // 把新加和已有的加进去
          var tempAnswer = []
          if (vm.item.answers != null) {
            vm.item.answers.forEach((i) => {
              tempAnswer.push(i)
            })
          }
          if (vm.addAnswer != null) {
            vm.addAnswer.forEach((i) => {
              tempAnswer.push(i)
            })
          }
          tempAnswer.push(vm.currentItem)
          //   vm.activeAddAnswer = tempAnswer;
          vm.$emit('updateRuleResult', vm.item.questionCode, tempAnswer)
        }
      }

      // 如果是单选题，选中时就更新，不需要点击，需要是多选还需要点+号
      if (!vm.item.multipleChoiceFlag && vm.currentItem.optionalCode != 0) {
        vm.checkItemIsAdded()
        var updateItem = [
          {
            optionalCode: vm.currentItem.optionalCode,
            optionalName: vm.currentItem.optionalName,
            happenTime: vm.currentItem.happenTime,
            remark: vm.currentItem.remark
          }
        ]
        vm.$emit('updateRuleResult', vm.item.questionCode, updateItem)
      }
      console.info(value)
      if (value == -1) {
        var updateArray = []
        if (vm.addAnswer != null) {
          vm.addAnswer.forEach((i) => {
            updateArray.push(i)
          })
        }
        if (vm.item.answers != null) {
          vm.item.answers.forEach((i) => {
            updateArray.push(i)
          })
        }
        vm.$emit('updateRuleResult', vm.item.questionCode, updateArray)
      }
    },
    checkItemIsAdded() {
      var newItem = []
      this.item.options.forEach((loopItem) => {
        var isExists = false
        this.addAnswer.forEach((i) => {
          // 在新加的回答里是否有当前规则
          if (i.optionalCode == loopItem.optionalCode) {
            isExists = true
          }
        })
        if (this.item.answers != null) {
          this.item.answers.forEach((i) => {
            // 在历史回答里是否有当前规则
            if (i.optionalCode == loopItem.optionalCode) {
              isExists = true
            }
          })
        }

        // 如果当前规则已经还不存在，或者当前是单选，即显示内容
        if (!isExists || !this.item.multipleChoiceFlag) {
          newItem.push(loopItem)
        }
      })
      this.showOptions = newItem
    }
  }
}
</script>

<style></style>
